import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'EventEditLayout',
  props: {
    title: null,
    description: null,
    loading: { type: Boolean },
    error: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})